(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/product-start-page/assets/javascripts/promos/views/match-promo.js') >= 0) return;  svs.modules.push('/components/app/product-start-page/assets/javascripts/promos/views/match-promo.js');

'use strict';

svs.app.productStartPage.promos.views.MatchPromo = Marionette.View.extend({
  className: 'match-promo',
  template: function(data) {
    return svs.app.product_start_page.templates.match_promo(data);
  },
  ui: {
    button: '.js-default-promo-button'
  },
  events: {
    'click @ui.button': 'buttonClick'
  },
  initialize: function() {
    if (this.model.collection.length === 1) {
      this.$el.addClass('col-xs-12');
    } else if (this.model.collection.length === 2) {
      this.$el.addClass('col-xs-12 col-md-6');
    } else if (this.model.collection.length === 3) {
      this.$el.addClass('col-xs-12 col-md-4');
    } else if (this.model.collection.length === 4) {
      if (this.options.itemIndex === 0) {
        this.$el.addClass('col-xs-12 col-sm-6 col-md-12');
      } else {
        this.$el.addClass('col-xs-12 col-sm-6 col-md-4');
      }
    } else if (this.model.collection.length === 5) {
      if (this.options.itemIndex === 0) {
        this.$el.addClass('col-xs-12 col-sm-12 col-md-6');
      } else if (this.options.itemIndex === 1) {
        this.$el.addClass('col-xs-12 col-sm-6 col-md-6');
      } else {
        this.$el.addClass('col-xs-12 col-sm-6 col-md-4');
      }
    } else if (this.model.collection.length === 6) {
      this.$el.addClass('col-xs-12 col-sm-6 col-md-4');
    } else if (this.model.collection.length === 7) {
      if (this.options.itemIndex === 0) {
        this.$el.addClass('col-xs-12 col-sm-12 col-md-6');
      } else if (this.options.itemIndex === 1) {
        this.$el.addClass('col-xs-12 col-sm-6 col-md-6');
      } else if (this.options.itemIndex === 2) {
        this.$el.addClass('col-xs-12 col-sm-6 col-md-4');
      } else if (this.options.itemIndex === 3) {
        this.$el.addClass('col-xs-12 col-sm-6 col-md-4');
      } else if (this.options.itemIndex === 4) {
        this.$el.addClass('col-xs-12 col-sm-6 col-md-4');
      } else {
        this.$el.addClass('col-xs-12 col-sm-6 col-md-6');
      }
    }
  },
  buttonClick: function(e) {
    var buttonId = $(e.target).data('button');

    buttonId = parseInt(buttonId, 10) - 1;

    if (
      this.model.get('buttons') &&
        this.model.get('buttons')[buttonId] &&
        this.model.get('buttons')[buttonId].callback
    ) {
      this.model.get('buttons')[buttonId].callback();
    }
  }
});



 })(window);